import React, {useState, useEffect} from 'react';
import styled from '@emotion/styled';
import {useDropzone} from 'react-dropzone';

/*open source npm module
documentation @ https://www.npmjs.com/package/react-dropzone */

const Section = styled.section`
  width: 100%;
  height: 100%;
  
  > div:first-of-type {
    display: flex;
    align-items: center;
    justify-content: center;
    
    width: 100%;
    height: 100%;
  }
`

const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  
  align-items: center;
  
  > p {
    display: flex;
    align-items: center;
    
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    color: var(--color-gray-600);
    
    cursor: pointer;
    
    > span > img {
      margin-left: var(--space-16);
    }
  }
`;

function CustomDropzoneComponent({text, upload, onDrop}) {
    const {acceptedFiles, getRootProps, getInputProps} = useDropzone({onDrop});

    const files = acceptedFiles.map(file => <li key={file.path}>{file.path} - {file.size} bytes</li>);

    return <Section>
        <div {...getRootProps()}>
            <input {...getInputProps()} onChange={upload}/>
            <InnerContainer>
                <p>{text}<span><img className='field-icon' src='/header/display-3-aux/cloudshare_icon.svg' alt='cloudshare icon'/></span></p>
            </InnerContainer>
        </div>
        {/*{files ? <aside><ul>{files}</ul></aside> : null}*/}
    </Section>;
}

export default CustomDropzoneComponent;
